import ForgotPassword from "./ForgotPassword.component";

export default ForgotPassword;
